import { EventEmitter, Inject, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import * as FaunaDB from 'faunadb';

import { AOService } from './ao.service';
import { AOEnvService } from './ao-env.service';
import { AOCacheService } from './ao-cache.service';

const _q = FaunaDB.query;

// @dynamic

@Injectable({
  providedIn: 'root'
})
export class AOFaunaDbService {

  private readonly _client: FaunaDB.Client;

  private readonly _cache: AOCacheService;

  public readonly q = _q;

  public readonly _observer = new EventEmitter<any>();

  // -------------------------------------------------------------------------------------------------------------------

  constructor(
    private _ao: AOService,
    private _storage: LocalStorageService,
    @Inject(AOEnvService) private _environment
  ) {
    this._cache = new AOCacheService(this, this._storage);
    this._client = new FaunaDB.Client({
      secret: this._environment.faunadb.secret,
      observer: (res: any) => this._observer.emit(res)
    });
  }

  client(): FaunaDB.Client {
    return this._client;
  }

  //--------------------------------------------------------------------------------------------------------------------
  // EXPRESSION
  //--------------------------------------------------------------------------------------------------------------------

  Ref(table: string, id?): FaunaDB.Expr {
    return id ? _q.Ref(_q.Collection(table), id) : null;
  }

  Get(table: string, id: any): FaunaDB.Expr {
    return _q.Get(_q.Ref(_q.Collection(table), id));
  }

  Create(table: string, data: any, id = null): FaunaDB.Expr {
    return _q.Let(
      {
        id: id ? id : _q.NewId()
      },
      _q.Create(
        _q.Ref(_q.Collection(table), _q.Var('id')),
        {
          data: {
            is_activated: true,
            ...data,
            id: _q.Var('id'),
            created_at: Date.now(),
            updated_at: Date.now(),
            deleted_at: null
          }
        }
      )
    );
  }

  Update(table: string, data: any, id: any): FaunaDB.Expr {
    return _q.Update(
      _q.Ref(_q.Collection(table), id),
      {
        data: {
          ...data,
          id,
          updated_at: Date.now()
        }
      }
    );
  }

  Delete(table: string, id: any): FaunaDB.Expr {
    return _q.Delete(
      _q.Ref(_q.Collection(table), id)
    );
  }

  //--------------------------------------------------------------------------------------------------------------------
  // RESOURCES
  //--------------------------------------------------------------------------------------------------------------------

  query(callback: (q) => FaunaDB.Expr, configs: any = {}): Promise<any> {
    const promise = new Promise(async (resolve, reject) => {

      const params = callback(_q);

      const request = configs.cache
        ? this._cache.find(params, () => this.client().query(params), configs.cache)
        : this.client().query(params);

      request.then(response => resolve(response), error => reject(error));

    });

    return this._ao.wait(promise);
  }

  id(): Promise<any> {
    return this.query(q => q.NewId());
  }

  find(table: string, id: any): Promise<any> {
    return this.query(() => this.Get(table, id));
  }

  insert(table: string, data: any, id = null): Promise<any> {
    return this.query(() => this.Create(table, data, id));
  }

  upgrade(table: string, data: any, id): Promise<any> {
    return this.query(() => this.Update(table, data, id));
  }

  save(table: string, data: any): Promise<any> {
    return data.id
      ? this.upgrade(table, data, data.id)
      : this.insert(table, data);
  }

  destroy(table: string, id): Promise<any> {
    return this.query(() => this.Delete(table, id));
  }

}

// private static _observer() {
//   return (res: any) => {
//
//     const dt = new Date();
//     const prefix = [dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate()].join('-');
//
//     ['x-read-ops', 'x-write-ops'].forEach((header) => {
//
//       let qt = parseInt(res.responseHeaders[header], 10);
//       qt = isNaN(qt) ? 0 : qt;
//
//       header = prefix + '-' + header;
//
//       let counter = parseInt(localStorage.getItem(header), 10);
//       counter = isNaN(counter) ? 0 : counter;
//       counter += qt;
//
//       localStorage.setItem(header, counter.toString());
//
//     });
//
//   };
// }
